import type { VizDataset } from "@/lib/ai/visualization/data/schema";

/**
 * SA aggregated timeseries dataset profile.
 */
export const SA_TIMESERIES_PROFILE: NonNullable<VizDataset["profile"]> = {
  datasetFamily: "sa.aggregated",
  variant: "timeseries",
  compareMode: "none",
  supportedViews: [
    "time-series-line",
    "time-series-area",
    "time-series-composed",
    "scatter-plot",
    "table",
  ],
};

/**
 * SA aggregated group summary dataset profile.
 *
 * @remarks
 * `groupSummaries` は 1 group = 1 summary row の category-wide dataset なので、
 * scatter にすると代表点だけが並ぶ analytically weak な図になりやすい。
 * relationship / outlier 読みは grouped row-based dataset か raw dataset へ寄せる。
 */
export const SA_GROUPS_PROFILE: NonNullable<VizDataset["profile"]> = {
  datasetFamily: "sa.aggregated",
  variant: "groups",
  compareMode: "none",
  supportedViews: ["bar-comparison", "bar-ranking", "table"],
};

/**
 * SA aggregated grouped row-based dataset profile.
 */
export const SA_GROUPS_TIMESERIES_ROWS_PROFILE: NonNullable<
  VizDataset["profile"]
> = {
  datasetFamily: "sa.aggregated",
  variant: "groups",
  compareMode: "none",
  supportedViews: [
    "bar-ranking",
    "bar-comparison",
    "time-series-line",
    "time-series-grouped-line",
    "time-series-area",
    "time-series-composed",
    "scatter-plot",
    "table",
  ],
};

/**
 * SA aggregated grouped period-compare row dataset profile.
 */
export const SA_GROUPS_TIMESERIES_COMPARE_ROWS_PROFILE: NonNullable<
  VizDataset["profile"]
> = {
  datasetFamily: "sa.aggregated",
  variant: "groups",
  compareMode: "period",
  supportedViews: [
    "bar-ranking",
    "bar-comparison",
    "time-series-line",
    "time-series-area",
    "time-series-composed",
    "scatter-plot",
    "table",
  ],
};

/**
 * SA aggregated period-compare dataset profile.
 */
export const SA_COMPARE_PROFILE: NonNullable<VizDataset["profile"]> = {
  datasetFamily: "sa.aggregated",
  variant: "timeseriesCompare",
  compareMode: "period",
  supportedViews: [
    "time-series-line",
    "time-series-area",
    "time-series-composed",
    "scatter-plot",
    "table",
  ],
};
